import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  DESCRIPTION,
  EUROPEAN_COMMERCE_CONTROL_NUMBER,
  HEIGHT,
  LENGTH,
  PART_NUMBER,
  WEIGHT,
  WIDTH
} from "MODULES/parts/constants";

export default function validate(values) {
  return validator(values, v => {
    v
      .validate("manufacturer_list_price", "purchased_at")
      .satisfies(
        rules.requiredIfAnyDefined("manufacturer_list_price", "purchased_at")
      );

    v
      .validate("special_container_fee")
      .satisfies(rules.requiredIfAnyDefined("special_container_req"));

    v.validate(PART_NUMBER, DESCRIPTION).satisfies(rules.required);
    if (
      !["EAR99", "SNCHK"].includes(values[EUROPEAN_COMMERCE_CONTROL_NUMBER])
    ) {
      v
        .validate(EUROPEAN_COMMERCE_CONTROL_NUMBER)
        .satisfies(
          rules.matchesPattern(
            /^[0-9][A-Za-z]\d{3}\.?[a-z]?\.?[0-9]?\.?[a-z]?$/
          )
        );
    }
    v.validate(WEIGHT).satisfies(rules.isNumeric, rules.isGreaterThan(0));
    v
      .validate(LENGTH, WIDTH, HEIGHT)
      .satisfies(
        rules.requiredIfAnyDefined(LENGTH, WIDTH, HEIGHT),
        rules.isNumeric,
        rules.isGreaterThan(0)
      );
    v
      .validate("united_nations_code")
      .satisfies(rules.isInteger, rules.lengthIsEqual(4));
  });
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/CreatePart/validate.js